import store from "@/store";

const isUserGuard = async(to, from, next) => {
    const { typeUser } = store.state.auth.user;
    if (typeUser !== 3) return next();
    else return next({ path: "/administrador" });
}

export default isUserGuard;